import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COOKIE } from "@/constants/testIds";

const KEY = "bfv24_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid={COOKIE.banner}
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[65] bg-[#0a1f1a] border border-emerald-500/30 text-white shadow-2xl rounded-md p-5"
    >
      <div className="overline text-emerald-400 mb-2">Rispettiamo la tua privacy</div>
      <p className="text-sm leading-relaxed text-white/75">
        Usiamo solo cookie tecnici necessari al funzionamento del sito.
        Nessun tracciamento pubblicitario. Leggi la nostra{" "}
        <Link to="/cookie" className="underline hover:text-emerald-400">Cookie Policy</Link>.
      </p>
      <div className="mt-4 flex items-center gap-2">
        <button
          data-testid={COOKIE.accept}
          onClick={() => handleChoice("accepted")}
          className="btn-primary text-xs px-4 py-2"
        >
          Accetta
        </button>
        <button
          data-testid={COOKIE.reject}
          onClick={() => handleChoice("rejected")}
          className="text-xs px-4 py-2 rounded-md border border-white/20 text-white hover:bg-white/5"
        >
          Solo essenziali
        </button>
      </div>
    </div>
  );
}
